import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Wedding Save The Date </h1>

    
    <div className="imgs max700">
        <div>
            <img src={require('../assets/graphicDesign/saveTheDate/mockup.jpg')} data-skip-gallery/>
        </div>
    </div>

    <p>I designed and created the displayed Save The Dates for my two friends 
    Danica and Nicholas. Their wedding will be in Koh Samui, Thailand, and we wanted 
    to create a postcard-themed Save The Date to get their friends and family 
    excited for the travel theme of their wedding. We were sure to include 
    the iconic Koh Samui boats as well as white flowers which will be used in their wedding.</p>

    <div className="imgs max600">
        <div>
            <img src={require('../assets/graphicDesign/saveTheDate/front.jpg')} data-skip-gallery/>
        </div>
    </div>

    <div className="imgs max600">
        <div>
            <img src={require('../assets/graphicDesign/saveTheDate/back.png')} data-skip-gallery/>
        </div>
    </div>

    
    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.